<script setup>
import { inject, ref, computed } from 'vue';
import Dropdown from 'primevue/dropdown';
import ModaleEditionCouleur from '@/components/modales/ModaleEditionCouleur.vue';

const { couleurParDefaut, premiereCouleurProposee } = defineProps({
    couleurParDefaut: Object,
    premiereCouleurProposee: Object
});

const couleur = defineModel('couleur', {
    type: [Object, String]
});

const couleurs = inject('couleurs');
const convertirRgbEnCouleur = inject('convertirRgbEnCouleur');
const convertirCouleurEnRgb = inject('convertirCouleurEnRgb');

const affichageModaleAjoutCouleur = ref(false);

const couleursProposees = computed(() => {
    const listeCouleurs = [couleurParDefaut];
    couleurs.value.map(texteRgb => convertirRgbEnCouleur(texteRgb)).forEach(couleur => listeCouleurs.push(couleur));
    if (couleur == 'multiple') {
        listeCouleurs.push(couleur);        
    }
    return listeCouleurs;
});

function modifierCouleur(c) {
    couleur.value = c;
}

function ajouterCouleur(c) {
    couleurs.value.push(convertirCouleurEnRgb(c));
    modifierCouleur(c);
}

</script>

<template>
    <div class="conteneur-selecteur-couleur">
        <Dropdown class="liste-modes-couleur"
          v-model="couleur" 
          :options="couleursProposees" 
          @change="modifierCouleur($event.value)">
            <template #value="slotProps">
                <template v-if="slotProps.value">
                    <div v-if="slotProps.value != 'multiple'" class="couleur-proposee" :style="{backgroundColor: `rgb(${slotProps.value.r}, ${slotProps.value.g}, ${slotProps.value.b})`}" />
                    <div v-else class="couleur-proposee multiple" />
                </template>
                <div v-else class="couleur-proposee couleur-defaut" :style="{backgroundColor: `rgb(${couleurParDefaut?.r}, ${couleurParDefaut?.g}, ${couleurParDefaut?.b})`}" />
            </template>
            <template #option="slotProps">
                <div v-if="slotProps.option != 'multiple'" class="couleur-proposee" :style="{backgroundColor: `rgb(${slotProps.option?.r}, ${slotProps.option?.g}, ${slotProps.option?.b})`}" />
                <div v-else class="couleur-proposee multiple" />
            </template>
        </Dropdown>
        <button class="bouton btn-ajout fas fa-plus" @click="affichageModaleAjoutCouleur = true"/>
		<ModaleEditionCouleur 
			v-if="affichageModaleAjoutCouleur"
			v-model:visible="affichageModaleAjoutCouleur"
            :ajout="true"
            :couleur-initiale="couleur ? couleur : premiereCouleurProposee" 
            @validation="(couleur) => ajouterCouleur(couleur)" />
    </div>
</template>

<style scoped>

.conteneur-selecteur-couleur {
    display: flex;
    align-items: stretch;
}

.liste-modes-couleur {
    margin-right: 1px;
}

.couleur-proposee {
    width: 30px;
    height: 10px;
    margin: 5px;
    margin-right: 0px;
    border: 1px solid black;
}

.multiple {
    background-image: linear-gradient(to right, red , yellow);
}

.couleur-defaut {
    opacity: 75%;
}

.btn-ajout {
    margin-left: 0px;
}

</style>
